module.exports = __webpack_public_path__ + "static/media/b3_levels_8-29.636b0b4a.png";